import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import useLogout from "../Hooks/useLogout";
import AlertField from "./AlertField";
import PasswordField from "./PasswordField";

const ChangePassword = () => {
  const axiosPrivate = useAxiosPrivate();
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();
  const logout = useLogout();

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const [values, setValues] = useState({
    current_password: "",
    new_password: "",
    re_new_password: "",
  });

  const inputs = [
    {
      id: 1,
      name: "current_password",
      type: "password",
      placeholder: "Enter current password",
      errorMessage: "Enter current password",
      label: "Old Password",
      required: true,
    },
    {
      id: 2,
      name: "new_password",
      type: "password",
      placeholder: "Enter new password",
      errorMessage:
        "Password should be 8-20 characters including 1 number and 1 special character!",
      label: "New Password",
      pattern: `^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$`,
      required: true,
    },
    {
      id: 3,
      name: "re_new_password",
      type: "password",
      placeholder: "Enter new password again",
      errorMessage: "Passwords don't match!",
      label: "Confirm Password",
      pattern: values.new_password,
      required: true,
    },
  ];

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const onUpdate = async (e) => {
    e.preventDefault();
    try {
      await axiosPrivate.put("auth/password/change/", values);
      //logging user out as it clears the cookie
      await logout();
      navigate("/login", {
        state: {
          message: "Password Updated.",
          type: "success",
        },
      });
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 400) {
        showAlert("Old password is not correct.", "warning");
      } else {
        showAlert("Update Failed", "warning");
      }
    }
  };

  return (
    <>
      <AlertField alert={alert} />
      <div className="pt-2 pb-4">
        <h2 className="text-center mb-4">Change Password</h2>
        <form onSubmit={onUpdate}>
          <div className="d-flex flex-column align-items-center">
            {inputs.map((input) => (
              <PasswordField
                key={input.id}
                {...input}
                value={values[input.name]}
                onChange={onChange}
              />
            ))}
          </div>
          <div className="text-center mt-4">
            <button className="btn btn-primary">Update Password</button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ChangePassword;
